import React from "react";
import "./Card.css";

function Card({ cardName, isTrump, highlight = false }) {
  const CARD_IMAGE_URL = `/cards/${cardName}.svg`;

  return (
    <div className="card-container" >
      <div
        className={`card ${isTrump && !highlight ? "trump" : ""} ${highlight ? "highlight" : ""}`}
        style={{
          backgroundImage: `url(${CARD_IMAGE_URL})`,
          backgroundSize: "cover"
        }}
      ></div>
    </div>
  );
}

export default Card;